export const LearnMoreList: {
    [key: string]: string;
} = {
    us: 'Learn More',
    eu: 'Learn More',
    uk: 'Learn More',
    za: 'Learn More',
    au: 'Learn More',
    ca: 'Learn More',
    cn: '了解更多信息',
    de: 'Mehr erfahren',
    fr: 'En savoir plus',
    it: 'Scopri di più',
    es: 'Más información',
    jp: '詳しくはこちら',
    kr: '더 알아보기',
    sa: ' اعرف المزيد',
    tw: '了解其他',
    br: 'Saber mais',
    mx: 'Más información',
    ph: 'Learn More',
};
